const standardiseString = (str: string): string => str.toLowerCase();

/** This class provides a URLSearchParams-like method to get case-insensitive
 * parameter values.
 */
export class DataSpaSearchParams {
  private caseInsensitiveParams: URLSearchParams;

  constructor(dataSpaParams: string) {
    const originalParams = new URLSearchParams(dataSpaParams);

    this.caseInsensitiveParams = new URLSearchParams();

    originalParams.forEach((value, name) => {
      const trimmedName = name.trim();
      const trimmedValue = value.trim();

      this.caseInsensitiveParams.append(standardiseString(trimmedName), trimmedValue);
    });
  }

  /** Returns the first value associated to the given search parameter. */
  get(name: string, options?: { defaultValue?: string }): string | null {
    return this.caseInsensitiveParams.get(standardiseString(name)) || options?.defaultValue || null;
  }

  /** Returns whether the first value associated to the given search parameter is one of a number of "true"-like values */
  getBoolean(name: string): boolean {
    const value = this.get(name);
    if (!value) {
      return false;
    }

    const truthyValues = ['true', 'yes', 'on'].map((v) => standardiseString(v));
    return truthyValues.includes(standardiseString(value));
  }
}
